export const _setEmployeeDetails = (state, action) => action.payload;
